import { useMemo } from 'react';

import { useMediaQuery } from '@mui/material';
import { ButtonGroup, Grid, noop } from '@kc-console/common-ui';

import { TooltipButtonGhost } from '../TooltipButton';
import { actionBarClasses } from './utils';

import type { ResourceAction } from '../ActionButtonsGroup';

export interface ActionBarActionsProps {
  actions: ResourceAction[];
  moreButtonLabel?: string;
  visibleActionsCount?: number;
}

const ActionBarButtonCountMap = {
  xs: 1,
  sm: 5,
  md: 5,
  lg: 5,
  xl: 5,
} as const;

export default function ActionBarActions(props: ActionBarActionsProps) {
  const { actions, moreButtonLabel, visibleActionsCount } = props;

  const isScreenUnderSm = useMediaQuery(theme => theme.breakpoints.down('sm'));

  const buttonCount = useMemo(() => {
    if (isScreenUnderSm) {
      return ActionBarButtonCountMap.xs;
    }

    return visibleActionsCount ?? ActionBarButtonCountMap.md;
  }, [isScreenUnderSm, visibleActionsCount]);

  return (
    <Grid className={actionBarClasses.toolbarButtonsActions} container alignItems="center">
      <ButtonGroup
        visibleButtonCount={buttonCount}
        moreButtonLabel={moreButtonLabel}
        moreButtonSize="md"
      >
        {actions.map((action, actionIndex) => {
          const { label, onClick, disabled, tooltipMessage, showDividerAbove } = action;
          return (
            <ButtonGroup.Item
              key={actionIndex}
              onClick={disabled ? noop : onClick} // ButtonGroup.Item에서 cloneElement를 통해 children으로 onClick 주입
              disabled={disabled} // ButtonGroup.Item에서 cloneElement를 통해 children으로 disabled 주입
              dropdownItemProps={{
                text: label,
                tooltip: tooltipMessage,
                showDividerAbove: actionIndex === buttonCount ? false : showDividerAbove,
              }}
            >
              <TooltipButtonGhost size="md" message={tooltipMessage ?? ''}>
                {label}
              </TooltipButtonGhost>
            </ButtonGroup.Item>
          );
        })}
      </ButtonGroup>
    </Grid>
  );
}
